import { CustomError } from '../../../lib/custom-error';

export class ValidationError extends CustomError {
  constructor(...args: ConstructorParameters<typeof CustomError>) {
    super(...args);
  }
}
